(() => {
  if (customElements.get('nv-us-money')) return;
  const currency = window.Currency;
  if (typeof currency?.convert !== 'function') return;
  const rate = currency.convert(1, 'EUR', 'USD');
  if (!Number.isFinite(rate) || rate <= 0) return;
  const dollars = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  class UsMoney extends HTMLElement {
    static observedAttributes = ['data-cents'];
    connectedCallback() { this.showEstimate(); }
    attributeChangedCallback() { if (this.isConnected) this.showEstimate(); }
    showEstimate() {
      const raw = this.getAttribute('data-cents');
      const cents = Number(raw);
      const root = this.shadowRoot || this.attachShadow({ mode: 'open' });
      if (!raw || !Number.isSafeInteger(cents) || cents < 0) {
        root.replaceChildren(document.createElement('slot'));
        return;
      }
      root.textContent = '≈ ' + dollars.format(cents * rate / 100) + ' USD';
    }
  }
  customElements.define('nv-us-money', UsMoney);
})();